import { faArrowsRotate } from "@fortawesome/pro-solid-svg-icons"
import IconAndTextButton from "../../IconAndTextButton"

type Props = {
  disabled: boolean
  isLoading: boolean
  onSync: () => void
}

const SyncInvoiceButton = ({ disabled, isLoading, onSync }: Props) => {
  return (
    <IconAndTextButton
      type="primary"
      icon={faArrowsRotate}
      text="Sync to QuickBooks"
      disabled={disabled}
      loading={isLoading}
      onClick={onSync}
    />
  )
}

export default SyncInvoiceButton
